<template>
  <div class="login-page">
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="img-wrapper">
          <router-link :to="{ name: 'home' }">
            <img :src="companyLogo" alt="company logo" />
          </router-link>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right" />
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div
        class="full-page lock-page full-page-background"
        :data-image="fullPageBackground"
        :style="`background-image: url(${fullPageBackground})`"
      >
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <form ref="form" @submit="unlockUser">
            <div class="card card-lock p-xs">
              <div class="author">
                <img ref="avatar" class="avatar" :src="userAvatar" />
              </div>
              <h4>{{ user.fullName }}</h4>
              <div class="form-group">
                <input
                  type="password"
                  placeholder="Enter Password"
                  class="form-control"
                  required
                />
              </div>
              <button
                type="submit"
                class="btn btn-wd unlock-button submit-button"
                :class="{ loading: $wait.waiting(_uid) }"
              >
                Unlock
                <i
                  v-show="$wait.waiting(_uid)"
                  class="fas fa-circle-notch loading-icon"
                />
              </button>
              <div class="mt-xxs">
                <router-link :to="{ name: 'system@login' }">
                  Log in to another account
                </router-link>
              </div>
            </div>
          </form>
        </div>
        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              <span
                >&copy; 2006 - {{ year }} {{ reservedRightsWebSite }} All Rights
                Reserved.</span
              >
              <p>{{ getRevision() }}</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link :to="{ name: 'home' }"> Dashboard </router-link>
        </li>
      </ul>
    </div>

    <error-listener />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import ErrorListener from "@/components/UIComponents/ErrorListener";
import label from "@consts/label";
import createAvatar from "@helpers/createAvatar";

export default {
  components: { ErrorListener },
  data() {
    return {
      fullPageBackground: "static/img/background/login-page-background.jpg",
      year: moment().year(),
      reservedRightsWebSite: label.reservedRightsWebSite,
      companyLogo: label.companyLogo,
    };
  },

  computed: {
    ...mapGetters("userStore", ["user"]),
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    userAvatar() {
      return (
        this.user.avatar ||
        createAvatar({
          imgElement: this.$refs.avatar,
          fullName: this.user.fullName,
        })
      );
    },
  },
  methods: {
    ...mapActions("userStore", ["loginUser", "logoutUser"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapMutations("loadingStore", ["setLoading"]),
    async unlockUser(event) {
      event.preventDefault();
      const [inputPass] = this.$refs.form;
      const password = inputPass.value;

      if (!password) {
        return;
      }

      try {
        this.$wait.start(this._uid);
        await this.loginUser({
          userData: { username: this.user.username, password: inputPass.value },
        });

        this.$router.back();
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style scoped>
.unlock-button a {
  color: inherit;
}

.full-page-background {
  background-repeat: no-repeat;
  height: 100vh;
}

.navbar.navbar-absolute {
  z-index: 4;
}
</style>
